module.exports = __webpack_public_path__ + "img/attach_white.0489f3b5.svg";